export default __webpack_public_path__ + "static/media/labdigital.a204f34c.ttf";